import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, addDoc, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import ToolForm from '../components/ToolForm';
import { useUser } from '../UserContext';

const AddToolPage = () => {
  const { user } = useUser();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCategories = async () => {
      if (!user) {
        setError("Please log in to add a tool.");
        setLoading(false);
        return;
      }

      try {
        const categoriesCollection = collection(db, 'toolCategories');
        const categoriesSnapshot = await getDocs(categoriesCollection);
        const categoriesData = categoriesSnapshot.docs.map(doc => ({
          id: doc.id,
          name: doc.data().name
        }));
        setCategories(categoriesData);
      } catch (err) {
        console.error("Error fetching categories: ", err);
        setError("Failed to load categories. Please try again later.");
      }

      setLoading(false);
    };

    fetchCategories();
  }, [user]);

  const handleSubmit = async (toolData) => {
    if (!user) {
      setError('You must be logged in to add a tool.');
      return;
    }

    try {
      // Remove imageFiles from the data to be saved to Firestore
      const { imageFiles, ...dataToAdd } = toolData;

      const toolsCollection = collection(db, 'tools');
      const docRef = await addDoc(toolsCollection, {
        ...dataToAdd,
        ownerId: user.uid,
        createdAt: new Date()
      });
      console.log('Tool added successfully with ID:', docRef.id);
      navigate('/my-tools'); // Redirect to My Tools page after successful addition
    } catch (err) {
      console.error('Error adding tool:', err);
      setError('Failed to add the tool. Please try again.');
    }
  };

  if (loading) {
    return <div className="text-center mt-8">Loading...</div>;
  }

  if (error) {
    return <div className="text-center mt-8 text-red-500">{error}</div>;
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">Add a New Tool</h1>
      {categories.length > 0 && (
        <ToolForm onSubmit={handleSubmit} categories={categories} />
      )}
    </div>
  );
};

export default AddToolPage;